import { l } from '../../lib/imports'
import { common } from '../../main/common-sidecar'
import { chessAiRando } from './ai/chessAiRando-sidecar'
import { chessGameMode_game } from './chessGameMode_game-sidecar'
import { chessGameMode_menuMain } from './chessGameMode_menuMain-sidecar'
import { EChessTeam } from './chessPieces'
import { EChessHostCommand } from './messages/chessMessageHostCommand'
import { chessMessageHostCommand } from './messages/chessMessageHostCommand-sidecar'
import { chessWebsockets } from './messages/chessWebsockets-sidecar'
import { chessUiMultiplayerCursors } from './ui/chessUiMultiplayerCursors-sidecar'

export type ChessGameModeType = 'init' | 'main-menu' | 'game'

export interface IChessGameModeManager {
  isPaused: boolean
  generator: Generator<number, number, number> | null
  generator_exit: (() => void) | null
  generatorPauseSeconds: number
  mode: ChessGameModeType
  handicap: number
  team: EChessTeam
}

let _obj: IChessGameModeManager | null = null
export function get() {
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

// export function togglePause() {
//   messageGeneralCommand.sendMessageAndImmediatelyExecute({
//     command: get().isPaused ? EGeneralCommand.Unpause : EGeneralCommand.Pause,
//   })
// }

export function networkPause(isPaused: boolean) {
  get().isPaused = isPaused
}

function create() {
  let obj: IChessGameModeManager = {
    generator: null,
    generator_exit: null,
    generatorPauseSeconds: 0,
    isPaused: false,
    mode: 'init',
    handicap: 0,
    team: EChessTeam.Spectator,
  }
  return obj
}

export function addHandicap(h: number) {
  let obj = get()
  setHandicap(obj.handicap + h)
}
export function resetHandicap() {
  setHandicap(0)
}
export function setHandicap(v: number) {
  let obj = get()
  obj.handicap = v
  if (chessWebsockets.getIsHost()) {
    chessMessageHostCommand.sendToOthers({
      command: EChessHostCommand.Handicap,
      handicap: obj.handicap,
    })
  }
}

export function sendHandicap() {}

export interface IChessPlayerTeam {
  isUs?: boolean
  isEmpty?: boolean
  multiId: number
  name: string
  team: EChessTeam
}
export function getPlayer(team: EChessTeam): IChessPlayerTeam {
  let obj = get()
  if (obj.team === team) {
    return {
      isUs: true,
      team: team,
      multiId: chessWebsockets.getMultiId(),
      name: chessWebsockets.getMultiName(),
    }
  }
  let ret = l.find(chessUiMultiplayerCursors.getAll(), (c) => c.team === team)
  if (ret) {
    return {
      team: team,
      multiId: ret.multiId,
      name: ret.name,
    }
  }

  let ret2 = l.find(chessAiRando.getAll(), (c) => c.team === team)
  if (ret2) {
    return {
      team: team,
      multiId: 0,
      name: ret2.name,
    }
  }

  return {
    isEmpty: true,
    team: team,
    multiId: 0,
    name: 'Empty',
  }
}
export function getSpectators() {
  let spectators: IChessPlayerTeam[] = []
  let obj = get()
  if (obj.team === EChessTeam.Spectator) {
    spectators.push({
      isUs: true,
      team: EChessTeam.Spectator,
      multiId: chessWebsockets.getMultiId(),
      name: chessWebsockets.getMultiName(),
    })
  }
  l.forEach(chessUiMultiplayerCursors.getAll(), (c) => {
    if (
      c.team === EChessTeam.Spectator &&
      c.multiId !== chessWebsockets.getMultiId()
    ) {
      spectators.push({
        team: EChessTeam.Spectator,
        multiId: c.multiId,
        name: c.name,
      })
    }
  })
  return spectators
}

export function update() {
  let obj = get()

  let ds = common.getUpdateDeltaScaled()

  if (obj.generatorPauseSeconds > 0) {
    obj.generatorPauseSeconds -= ds
    return
  }

  if (obj.generator) {
    let generatorResult = obj.generator.next()
    if (generatorResult.done) {
      // console.log('Generator is done!')
    } else {
      obj.generatorPauseSeconds = generatorResult.value
    }
  }
}

function switchMode(
  newMode: ChessGameModeType,
  generator: Generator<number, number, number> | null,
  generatorExit: () => void = () => {},
) {
  let obj = get()
  exitCurrentMode()
  obj.mode = newMode
  obj.generator = generator
  obj.generator_exit = generatorExit
}

function exitCurrentMode() {
  let obj = get()
  if (obj.generator_exit) {
    obj.generator_exit()
    obj.generator_exit = null
  }
}

// export function goLoading() {
//   switchMode('loading', voyageGameMode_loading.generator_loading())
// }
export function goMenuMain() {
  chessUiMultiplayerCursors.killAll()
  switchMode('main-menu', chessGameMode_menuMain.generator_menuMain())
}
// export function goEditor() {
//   switchMode('editor', voyageGameMode_editor.generator_editor())
// }
// export function goBodyAlign() {
//   switchMode('body-align', voyageGameMode_bodyAlign.generator_bodyAlign())
// }
export function goGame() {
  switchMode('game', chessGameMode_game.generator_game())
}
